import { render } from "./OnboardingStep1.vue?vue&type=template&id=470da7ce"
import script from "./OnboardingStep1.vue?vue&type=script&lang=ts"
export * from "./OnboardingStep1.vue?vue&type=script&lang=ts"
script.render = render

export default script